import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ASSETS, BRAND } from "../lib/api";
import { Loader2, LogIn } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const next = location.state?.from || "/admin";
      navigate(next, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center p-6" style={{ background: "#0F1D14" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center">
          <img src={ASSETS.logo} alt="HBS" className="h-28 mx-auto mb-4 bg-white rounded-sm p-2" />
        </Link>
        <h1 className="text-center font-serif-bv text-3xl text-[#D4AF37] tracking-wider">{BRAND.short} OPERATIONS</h1>
        <p className="text-center text-xs tracking-[0.3em] uppercase text-[#F5EFE0]/60 mt-2">{BRAND.name_line1} • {BRAND.name_line2}</p>

        <form onSubmit={submit} data-testid="login-form" className="mt-8 bg-[#1B3022] border border-[#D4AF37]/40 rounded-sm p-8 shadow-2xl">
          <h2 className="font-serif-bv text-xl text-[#F5EFE0] mb-5">Sign in</h2>
          <label className="block mb-4">
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#F5EFE0]/70">Email</span>
            <input
              data-testid="login-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-4 py-3 bg-[#0F1D14] border border-[#D4AF37]/30 rounded-sm text-[#F5EFE0] outline-none focus:border-[#D4AF37]"
            />
          </label>
          <label className="block mb-6">
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#F5EFE0]/70">Password</span>
            <input
              data-testid="login-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-4 py-3 bg-[#0F1D14] border border-[#D4AF37]/30 rounded-sm text-[#F5EFE0] outline-none focus:border-[#D4AF37]"
            />
          </label>
          {error && (
            <p data-testid="login-error" className="mb-4 text-sm text-[#E5A07A] border border-[#C8102E]/40 bg-[#C8102E]/10 px-3 py-2 rounded-sm">
              {error}
            </p>
          )}
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-gold w-full rounded-sm py-3 text-xs flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={14} /> : <LogIn size={14} />}
            Sign in
          </button>
        </form>
        <p className="text-center text-xs text-[#F5EFE0]/40 mt-6">
          <Link to="/" className="hover:text-[#D4AF37]">← back to {BRAND.domain}</Link>
        </p>
      </div>
    </div>
  );
}
